import React from 'react';
import { ImageIcon } from 'lucide-react';
type ImageSlotProps = {
  url?: string;
  alt: string;
  /** Shown inside the placeholder so you know which constant feeds it */
  slotName: string;
  className?: string;
  fit?: 'cover' | 'contain';
  eager?: boolean;
};
export function ImageSlot({
  url,
  alt,
  slotName,
  className = '',
  fit = 'cover',
  eager = false
}: ImageSlotProps) {
  if (url) {
    return <img src={url} alt={alt} loading={eager ? 'eager' : 'lazy'} className={`h-full w-full ${fit === 'cover' ? 'object-cover' : 'object-contain'} ${className}`} data-id="element-133" data-mp="2jh02oijqirjg" />;
  }
  return <div role="img" aria-label={alt} className={`flex h-full w-full flex-col items-center justify-center gap-2 rounded-xl border border-mist-line bg-mist p-4 text-center text-brand ${className}`} data-id="element-134" data-mp="2t6jr03q7vdlp">
      <ImageIcon className="h-6 w-6" strokeWidth={1.5} aria-hidden="true" data-id="element-135" data-mp="324lnc5z09i2n" />
      <span className="font-mono text-[10px] uppercase tracking-[0.14em]" data-id="element-136" data-mp="376axzkibftq7">{slotName}</span>
    </div>;
}